import { ProviderContractDatabase } from "../../../../types";
import useDeleteProviderContract from "../../api/useDeleteProviderContract";
import ConfirmDeleteDialog from "../../../../components/ConfirmDeleteDialog/ConfirmDeleteDialog";

type Props = {
  contract: ProviderContractDatabase;
  onClose: () => void;
}

export default function DeleteContractModal(props: Props) {
  const { mutateAsync } = useDeleteProviderContract();

  return (
    <ConfirmDeleteDialog
      title="Supprimer le contrat"
      onConfirm={() => mutateAsync({
        providerId: props.contract.provider_id,
        contractId: props.contract.id,
        documentId: props.contract.document_id ?? null,
      })}
      onClose={props.onClose}
    >
      Êtes-vous sûr de vouloir supprimer le contrat « {props.contract.name} » ?
    </ConfirmDeleteDialog>
  );
}
